var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "42px",
    viewBox: "0 0 72 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Loghi/GK") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03_Login_user",
    transform: "translate(-51.000000, -57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(51.864000, 57.440000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.424,15.552 L18.384,15.552 L18.384,22.128 L24.144,22.128 C23.856,22.56 23.52,22.944 23.136,23.328 C21.696,24.768 19.92,25.488 17.856,25.488 C15.792,25.488 14.016,24.768 12.528,23.328 C11.088,21.84 10.368,20.064 10.368,18 C10.368,15.936 11.088,14.16 12.528,12.72 C14.016,11.232 15.792,10.512 17.856,10.512 C19.92,10.512 21.36,10.944 22.8,12.384 L30.48,5.376 C26.976,1.872 22.8,0.096 17.856,0.096 C12.96,0.096 8.736,1.872 5.232,5.376 C1.728,8.832 -5.68434189e-14,13.056 -5.68434189e-14,18 C-5.68434189e-14,22.896 1.728,27.12 5.232,30.624 C8.736,34.08 12.96,35.856 17.856,35.856 C22.8,35.856 26.976,34.08 30.48,30.624 C33.984,27.12 35.424,22.896 35.424,18 C35.424,17.856 35.424,17.712 35.424,17.568 C35.424,17.088 35.424,15.552 35.424,15.552 Z",
    fill: "#EC6E1E"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#338ACA",
    points: "62.544 40.752 48.72 23.04 48.72 34.56 38.352 34.56 38.352 1.296 48.72 1.296 48.72 12.192 60.864 0 68.16 7.344 57.936 17.616 70.752 34.56"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGk);
export default __webpack_public_path__ + "static/media/GK.7a60e722601ba01551d8e5a0c1a0f34c.svg";
export { ForwardRef as ReactComponent };